import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 10 10",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M8.39 6.73 5.18 3a.24.24 0 0 0-.36 0l-3.2 3.72c-.13.14-.02.34.17.34h6.42c.19 0 .3-.2.18-.34Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgTriangleUp);
export default ForwardRef;
